<template>
  <div>

    <!-- Header: Personal Info -->

    <!-- Form: Personal Info Form -->
    <b-card
        no-body
        class="border mt-1"
    >
      <b-card-header class="p-1">
        <b-card-title class="font-medium-2">
          <feather-icon
              icon="LockIcon"
              size="18"
          />
          <span class="align-middle ml-50">Lista de permissões</span>
        </b-card-title>
      </b-card-header>
{{ todosPerfils }}
      <b-table striped responsive class="mb-0" :items="todosPerfils" :fields="tabelaPerfils">
        <template #cell(status)="data">
          <div>
            <b-form-checkbox
                v-model="data.item.status"
                :checked="data.item.status"
                class="custom-control-success"
                name="check-button"
                switch
            />
          </div>
        </template>
      </b-table>
    </b-card>

    <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        @click="() => onSubmit(userData,todosPerfils)"
    >
      Salvar Alterações
    </b-button>
    <b-button
        variant="outline-secondary"
        type="reset"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Cancelar
    </b-button>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BButton,
  BFormCheckbox,
  BCard,
  BTable,
  BCardTitle, BCardHeader,
} from 'bootstrap-vue';
import flatPickr from 'vue-flatpickr-component';
import { watch, ref } from '@vue/composition-api';
import vSelect from 'vue-select';
import store from '@/store';
import Notifier from '@/libs/Notifier';

export default {
  components: {
    BCardHeader,
    BCardTitle,
    BTable,
    BCard,
    BFormCheckbox,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    todosPerfils: {
      type: Array,
      required: true,
    },
  },

  setup(props) {
    const notify = new Notifier();
    const tabelaPerfils = [
      { key: 'perfil_acesso_nome', label: 'Nome', sortable: true },
      { key: 'status', label: 'Status' },
    ];

    const portalCliente = props.todosPerfils;
    console.log(portalCliente);
    const onSubmit = (userData, todosPerfils) => {
      const { id } = userData;
      store.dispatch('app-user/putPerfilsUsuario', { todosPerfils, id })
        .then(() => {
          notify.success('Alterado com sucesso');
        });
    };

    return {
      onSubmit,
      tabelaPerfils,
      portalCliente,

    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker';
</style>
